import React from 'react';
import { useLocation } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: undefined, componentStack: undefined };
    this.reset = this.reset.bind(this);
  }

  reset() {
    this.setState({ error: undefined, componentStack: undefined });
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    this.setState({ componentStack: errorInfo?.componentStack });
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.locationKey !== this.props.locationKey) {
      this.reset();
    }
  }

  render() {
    const { error, componentStack } = this.state;
    const { fallback, children } = this.props;
    const FallbackComponent = fallback;

    if (error) {
      return fallback
        ? <FallbackComponent error={error} componentStack={componentStack} resetError={this.reset} />
        : <span>Something went wrong.</span>;
    }

    return children;
  }
}

export function ErrorBoundaryWithRouter({ fallback, children }) {
  const location = useLocation();
  return (
    <ErrorBoundary fallback={fallback} locationKey={location.key}>
      {children}
    </ErrorBoundary>
  );
}

export default ErrorBoundary;
